import { atom } from 'recoil';

// Globally Accessible Recoil Atoms
// Usage: Shared state variables across all components - only add an atom if its value will change over time:
const currentUserAtom = atom({ key: 'currentUser', default: {} });
const showCookieConsentAtom = atom({ key: 'showCookieConsentModal', default: false});
const showQsuAtom = atom({ key: 'showQsuModal', default: false });
const showRaqAtom = atom({ key: 'showRaqModal', default: false });
const showLaeAtom = atom({ key: 'showLaeModal', default: false });
const laeAtom = atom({ key: 'loanApprovalEstimate', default: '' });
const themesAtom = atom({ key: 'muiThemes', default: {} });
const defaultSiteCultureCodeAtom = atom({ key: 'defaultSiteCultureCode', default: '' });
const defaultSiteLangCodeAtom = atom({ key: 'defaultSiteLangCode', default: '' });
const sitePhoneFormatCultureCodeAtom = atom({ key: 'sitePhoneFormatCultureCode', default: '' });
const hasLanguageSelectorAtom = atom({ key: 'hasLanguageSelector', default: false });
const hasCountrySelectorAtom = atom({ key: 'hasCountrySelector', default: false });
const countryCode = atom({ key: 'countryCode', default: false });
const isInTranslationEditorModeAtom = atom({ key: 'isInTranslationEditorMode', default: false });
const currentWebsiteModelAtom = atom({ key: 'currentWebsite', default: {} });
const routesAtom = atom({ key: 'routes', default: {} });
const isModalOpen = atom({ key: 'isModalOpen', default: false });
const showEmployeeOnlyBetaSiteToggleAtom = atom({ key: 'showEmployeeOnlyBetaSiteToggle', default: false });
const isAuctionResultAtom = atom({ key: 'isAuctionResult', default: false });
const keywordSearchStateAtom = atom({ key: 'keywordSearchState', default: { SearchText: '' } });

export default {
    currentUser: currentUserAtom,
    showCookieConsent: showCookieConsentAtom,
    showQsu: showQsuAtom,
    showRaq: showRaqAtom,
    showLae: showLaeAtom,
    lae: laeAtom,
    muiThemes: themesAtom,
    defaultSiteCultureCode: defaultSiteCultureCodeAtom,
    defaultSiteLangCode: defaultSiteLangCodeAtom,
    sitePhoneFormatCultureCode: sitePhoneFormatCultureCodeAtom,
    hasLanguageSelector: hasLanguageSelectorAtom,
    hasCountrySelector: hasCountrySelectorAtom,
    countryCode: countryCode,
    isInTranslationEditor: isInTranslationEditorModeAtom,
    currentWebsite: currentWebsiteModelAtom,
    routes: routesAtom,
    isModalOpen: isModalOpen, 
    showEmployeeOnlyBetaSiteToggle: showEmployeeOnlyBetaSiteToggleAtom,
    isAuctionResult: isAuctionResultAtom,
    keywordSearchStateAtom: keywordSearchStateAtom
};